import { render, staticRenderFns } from "./TasksIndex.vue?vue&type=template&id=2d2d84c9&"
import script from "./TasksIndex.vue?vue&type=script&lang=js&"
export * from "./TasksIndex.vue?vue&type=script&lang=js&"
import style0 from "./TasksIndex.vue?vue&type=style&index=0&id=2d2d84c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports